import type { PromotionMetadata } from '@core/Entities/Vehicle/VehiclePromotionMetadata.entity';
import { Typography } from '@gds/Typography/Typography';

import styles from './OfferModal.module.css';

interface PromotionProps {
  promotion: PromotionMetadata;
}

const Promotion = ({ promotion }: PromotionProps) => {
  const {
    name,
    description,
    settings: { theme },
  } = promotion;

  return (
    <div className={styles[theme]}>
      <div className={styles.campaignTitle}>
        <Typography variant="h3" Component="p">
          {name}
        </Typography>
      </div>
      <div className={styles.campaignDescription}>
        <Typography variant="body3" Component="p">
          {description}
        </Typography>
      </div>
    </div>
  );
};

interface OfferModalComponentProps {
  promotions: PromotionMetadata[];
  title: string;
}

export const PromotionsModal = ({ promotions, title }: OfferModalComponentProps) => (
  <>
    <div className={styles.campaignHeader}>{title}</div>

    {promotions.map(promotion => (
      <Promotion promotion={promotion} key={promotion.promotionCode} />
    ))}
  </>
);
